module.exports = __webpack_public_path__ + "img/ranking-shop-img.f994e403.png";